import {
  GET_CONDITIONS_SUCCESS,
  GET_CONDITIONS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  conditions: [],
  error: {},
}

const conditions = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CONDITIONS_SUCCESS:
      return {
        ...state,
        conditions: action.payload,
      }

    case GET_CONDITIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default conditions
